import { transferServerMaterialLayerToClient } from '@/hooks/fetch-template/server-to-client';
import { editor } from '@/instance';

export const useAddMaterial = () => {
    return {
        /**
         * 添加图片素材
         *
         * @param params - 参数
         */
        async add({
            id,
            data,
            stageWidth,
            stageHeight,
            isPhoto = false,
            showLoading = true,
            byMousePosition = false,
        }: {
            id: number | string;
            data: any;
            stageWidth: number;
            stageHeight: number;
            isPhoto?: boolean;
            showLoading?: boolean;
            byMousePosition?: boolean;
        }) {
            try {
                if (showLoading) {
                    editor.tip.showMask({
                        loading: true,
                        text: '加载中',
                    });
                }
                data.material_conf.layer.materialIds['img-material'] = [id];

                const { templateConfs, replaceFamilies, replaceFamilyLayerIds } =
                    await transferServerMaterialLayerToClient(
                        data.material_conf,
                        stageWidth,
                        stageHeight,
                        editor.font.getList(),
                    );

                editor.textLayer.addByMaterialLayer(templateConfs, byMousePosition); // WHY: 这里为啥用文本图层的添加方法
            } catch (e) {
                console.log(e);
                if (showLoading) editor.tip.hideMask();
            } finally {
                if (showLoading) editor.tip.hideMask();
            }
        },
    };
};
